import { render, staticRenderFns } from "./appButton.vue?vue&type=template&id=70a3a15b&scoped=true&"
import script from "./appButton.vue?vue&type=script&lang=js&"
export * from "./appButton.vue?vue&type=script&lang=js&"
import style0 from "./appButton.vue?vue&type=style&index=0&id=70a3a15b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3a15b",
  null
  
)

export default component.exports